import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LinkIcon from '@houzz/icons/Link';
import { Icon, Link } from '@houzz/ui';

const HiddenLink = styled(Link)`
    position: absolute;
    left: -20px;
    opacity: 0;
    top: 50%;
    transform: translateY(-50%);
    transition: all 220ms;

    h1:hover &,
    h2:hover &,
    h3:hover &,
    h4:hover &,
    h5:hover &,
    h6:hover & {
        opacity: 1;
    }

    h3 & {
        margin-top: -6px;
    }
`;

const Heading = (Tag) => {
    const HeadingTag = (props) => {
        const withBorder = Tag === 'h3';
        if (!props.id) {
            return <Tag {...props} />;
        }

        return (
            <Tag
                {...props}
                style={{
                    position: 'relative',
                    ...(withBorder && { paddingBottom: '12px', borderBottom: '1px solid #eee' }),
                }}
            >
                <HiddenLink href={`#${props.id}`} linkStyle="tertiary" size="xSmall">
                    <Icon as={LinkIcon} />
                </HiddenLink>
                {props.children}
            </Tag>
        );
    };

    HeadingTag.propTypes = {
        id: PropTypes.string,
        children: PropTypes.node,
    };

    return HeadingTag;
};

Heading.displayName = 'Heading';
Heading.propTypes = {
    id: PropTypes.string,
    children: PropTypes.node,
};
export default Heading;
